module.exports = __webpack_public_path__ + "img/linkedin2.41950810.svg";